import { ContextMenuGroup, ContextMenuItem, Text } from '@wfp/react';
import React, { FC } from 'react';

import { gaParamPosition } from 'src/types';
import { sendGAEvent } from 'src/utils';

interface Props {
  exportContent: (commentsOnly: boolean, narrativesOnly: boolean) => void;
  gaPosition: gaParamPosition;
}

const IssuesOverviewContextualMenu: FC<Props> = ({ exportContent }) => {
  return (
    <>
      <ContextMenuGroup>
        <ContextMenuItem
          onClick={() => {
            sendGAEvent('comments_file_summary_generated', {
              wfp_position: 'comments_page',
              wfp_type: 'narratives_and_comments',
            });
            exportContent(false, false);
          }}
        >
          <Text>Narratives & Comments</Text>
        </ContextMenuItem>
      </ContextMenuGroup>
      <ContextMenuGroup>
        <ContextMenuItem
          onClick={() => {
            sendGAEvent('comments_file_summary_generated', {
              wfp_position: 'comments_page',
              wfp_type: 'narratives',
            });
            exportContent(false, true);
          }}
        >
          <Text>Only Narratives</Text>
        </ContextMenuItem>
      </ContextMenuGroup>
      <ContextMenuGroup className="io-context-menu-last-item">
        <ContextMenuItem
          onClick={() => {
            sendGAEvent('comments_file_summary_generated', {
              wfp_position: 'comments_page',
              wfp_type: 'comments',
            });
            exportContent(true, false);
          }}
        >
          <Text>Only Comments</Text>
        </ContextMenuItem>
      </ContextMenuGroup>
    </>
  );
};

export default IssuesOverviewContextualMenu;
